import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
interface Props {
  onNavigateHome: () => void;
}
export function Navbar({
  onNavigateHome
}: Props) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Konzept',
    href: '#konzept'
  }, {
    name: 'Pakete',
    href: '#pakete'
  }, {
    name: 'Partner',
    href: '#partner'
  }, {
    name: 'Blog',
    href: '#blog'
  }, {
    name: 'Kontakt',
    href: '#kontakt'
  }];
  const handleNavClick = (href: string) => {
    setMobileMenuOpen(false);
    onNavigateHome();
    setTimeout(() => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#020611]/80 backdrop-blur-md border-b border-border py-4' : 'bg-transparent py-6'}`} data-id="element-253">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-254">
        <button onClick={() => {
        onNavigateHome();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="hover:opacity-80 transition-opacity" data-id="element-255">
          <img src="https://cdn.magicpatterns.com/uploads/hEdhox844qFVGVrfYybLur/291EA45A-1FD8-43AC-AA88-9205857BA77E.jpg" alt="PEZULA AI" className="h-7" data-id="element-256" />
        </button>

        <nav className="hidden md:flex items-center gap-8" data-id="element-257">
          {navLinks.map(link => <button key={link.name} onClick={() => handleNavClick(link.href)} className="text-sm font-medium text-muted hover:text-accent transition-colors" data-id="element-258">
              {link.name}
            </button>)}
        </nav>

        <button className="md:hidden text-foreground" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-259">
          {mobileMenuOpen ? <X size={24} data-id="element-260" /> : <Menu size={24} data-id="element-261" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#020611] border-b border-border p-6 flex flex-col gap-4" data-id="element-262">
          {navLinks.map(link => <button key={link.name} onClick={() => handleNavClick(link.href)} className="text-lg font-medium text-foreground hover:text-accent transition-colors text-left" data-id="element-263">
              {link.name}
            </button>)}
        </div>}
    </motion.header>;
}